import { render, staticRenderFns } from "./Det.vue?vue&type=template&id=593390d0&scoped=true"
import script from "./Det.vue?vue&type=script&lang=js"
export * from "./Det.vue?vue&type=script&lang=js"
import style0 from "./Det.vue?vue&type=style&index=0&id=593390d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593390d0",
  null
  
)

export default component.exports